import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useMessageStore } from '@caradasstore/MessageStore'
import { X } from 'lucide-react'
import { AdasBox, AdasButton } from '@components/wrapper-components'

const SnackbarItem = ({ open, message, action, autoHideDuration = 6000, onClose }) => {
  const [visible, setVisible] = useState(open)

  useEffect(() => {
    setVisible(open)
    if (open && autoHideDuration) {
      const timer = setTimeout(() => {
        setVisible(false)
        onClose && onClose()
      }, autoHideDuration)
      return () => clearTimeout(timer)
    }
  }, [open, autoHideDuration, onClose])

  if (!visible) return null

  return (
    <div className='fixed bottom-4 right-4 z-[1400] min-w-[288px] max-w-[568px] bg-[#323232] text-white rounded px-4 py-3 shadow-lg flex items-center justify-between gap-2'>
      <span className='text-sm'>{message}</span>
      {action && <div>{action}</div>}
    </div>
  )
}

export const CaradasSnackbar = ({ message, open, onClose, onUndo }) => {
  const storeMessages = useMessageStore((store) => store.messages)
  const clearMessage = useMessageStore((store) => store.clearMessage)

  const isSingleMessage = message
  const allMessages = isSingleMessage ? [message] : storeMessages

  return (
    <>
      {allMessages.length > 0 &&
        allMessages.map((message, index) => (
          <SnackbarItem
            key={index}
            open={isSingleMessage ? open : true}
            autoHideDuration={6000}
            onClose={isSingleMessage ? () => onClose : () => clearMessage(message.id)}
            message={isSingleMessage ? message : message.text}
            action={
              isSingleMessage ? (
                <AdasBox>
                  <AdasButton color='inherit' size='small' onClick={onUndo}>
                    Undo
                  </AdasButton>
                  <X className='w-4 h-4' onClick={() => onClose(false)} style={{ float: 'right', cursor: 'pointer' }} />
                </AdasBox>
              ) : null
            }
          />
        ))}
    </>
  )
}

CaradasSnackbar.propTypes = {
  type: PropTypes.oneOf(['single', 'other']),
  messages: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onUndo: PropTypes.func
}
